import React from "react";

function Description({ product }) {
  return (
    <div
      className="tab-pane active f_detail-tab-panel"
      id="description-tab-panel"
      role="tabpanel"
      aria-labelledby="description-tab"
    >
      <div className="offcanvas-body">
        <div className="offcanvas-content-container product-detail-description tab-pane-container">
          <div
            className="h3 product-detail-description-title"
            style={{ color: "black", fontWeight: "bold", fontSize: "14px" }}
          >
            {product.name}
          </div>
          <div
            className="social-proof-text small1"
            style={{ fontSize: "14px" }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: product.description?.replace(/&nbsp;/g, " "),
              }}
            />
            {/* <svg className="ico-svg">
              <use href="#shield-logo"></use>
            </svg> */}
          </div>
          {/* <div style={styles.card}>
            <p style={styles.subtitle}>
              The Shield x sports’s Football Jersey combines a classic cut with
              exceptional comfort, making it the perfect choice for any football
              player. Crafted with CIO-TEX functional fiber, made from 100%
              polyester, it offers incredible durability and superior
              moisture-wicking technology, ensuring you stay dry even during
              intense play.
            </p>

            <div style={styles.container}>
              <p style={styles.paragraph}>
                <strong>Activity:</strong> Football (Men’s Football Jersey)
              </p>

              <p style={styles.paragraph}>
                <strong>Fabric:</strong> Breathable, moisture-wicking, and
                rapid-dry technology
              </p>

              <p style={styles.paragraph}>
                <strong>Collar:</strong> Elasticated Neck Type (Crew neck) that
                retains its shape over time
              </p>

              <p style={styles.paragraph}>
                <strong>Design and Style:</strong> 4-thread overlock at all
                seams, mid-weight fabric with Forwarded Shoulders and Flatlock
                Construction for ultimate comfort
              </p>

              <p style={styles.paragraph}>
                <strong>Product Info:</strong> Brand logo, set-in sleeves
              </p>

              <p style={styles.paragraph}>
                <strong>Care Instructions:</strong> Machine washable for easy
                care and maintenance
              </p>

              <p style={styles.paragraph}>
                Also, you can make this jersey match your team’s identity or
                your style. You can customize the Shield x sports’s Football
                Jersey by adding a name, number or design you choose.
              </p>

              <p style={styles.paragraph}>
                Ideal for <strong>Custom football t-shirts USA</strong> and{" "}
                <strong>Bulk order football jerseys</strong>, the R jersey
                offers unbeatable quality and style for football teams and fans
                alike.
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: {
    fontFamily: "'Arial', sans-serif",
    borderRadius: "8px",
    padding: "20px",
    fontSize: "14px",
    lineHeight: "1.5",
  },
  container: {
    marginTop:"10px",
  }
,  title: {
    fontSize: "18px",
    margin: "0 0 5px 0",
    color: "#333",
  },
  subtitle: {
    fontSize: "14px",
    color: "#666",
    margin: "0 0 15px 0",
    fontStyle: "italic",
  },
  features: {
    margin: "15px 0",
  },
  featureItem: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "8px",
  },
  checkmark: {
    color: "#2ecc71",
    marginRight: "8px",
    fontWeight: "bold",
  },
  cta: {
    marginTop: "20px",
    textAlign: "center",
  },
  button: {
    backgroundColor: "#e74c3c",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    transition: "background-color 0.3s",
  },
  bulkText: {
    fontSize: "12px",
    color: "#666",
    marginTop: "10px",
    fontStyle: "italic",
  },
  paragraph: {
    margin: "0 0 10px 0",
  },
};

export default Description;
